import HeaderAviso from './HeaderAviso';
import { ListItem, OrderedList } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { CabeceraSeccion, TextoAviso } from './moleculas/ElementosAvisos';
import { ContenidoAviso, ContenedorAviso } from './moleculas/ContenedorAviso';

const Politicas = () => {
  return (
    <ContenedorAviso>
      <HeaderAviso
        titulo='Políticas de privacidad'
        subtitulo='Últ. Revisión: 14/03/2024'
      />
      <ContenidoAviso>
        <CabeceraSeccion>PREÁMBULO</CabeceraSeccion>
        <TextoAviso>
          La presente Política de Privacidad tiene por finalidad informar a los
          Usuarios del tratamiento de los datos personales que el Usuario
          proporcione al utilizar o contratar los servicios de Progreso por
          medio de su plataforma digital denominada “Temba”, o por cualquiera de
          sus canales de comunicación o venta, tanto presenciales como remotos,
          a través del sitio web de Progreso (www.progreso.cl), sus aplicaciones
          informáticas / web, o por cualquier otro medio electrónico,
          telefónico, video, u otra tecnología y en su caso, a través de
          agentes, promotores, comisionistas, proveedores o socios comerciales.
        </TextoAviso>
        <TextoAviso>
          Tanto Progreso como los demás terceros autorizados, sólo efectuarán el
          tratamiento de los Datos Personales cuando cuenten con dicha
          autorización del Usuario o la Ley les reconozca otra base de legalidad
          para tratar Datos Personales y, únicamente para los fines autorizados
          en esta Política de Privacidad, en conformidad a la Ley Nº 19.628
          sobre Protección de la Vida Privada y demás regulación aplicable.
        </TextoAviso>
        <TextoAviso>
          El responsable por los datos personales que se recojan en conformidad
          a la presente Política de Privacidad es SERVICIOS FINANCIEROS PROGRESO
          S.A., Rol Único Tributario N° 90.146.000-0, domiciliado en Miraflores
          222 piso 25 Santiago, en adelante e indistintamente como “Progreso”.
        </TextoAviso>
        <TextoAviso>
          En caso de cualquier otra consulta acerca de la Política de Privacidad
          que se expone, por favor comunicarse al correo electrónico
          privacidad@progreso.cl
        </TextoAviso>
        <CabeceraSeccion>I. DATOS PERSONALES</CabeceraSeccion>
        <TextoAviso>
          Se entiende por datos de carácter personal o “Datos Personales”, los
          relativos a cualquier información concerniente a personas naturales,
          identificadas o identificables, que el Usuario entregue directamente
          en el curso de sus relaciones con Progreso y que sean necesarios para
          adquirir y utilizar los servicios que este ofrece o para requerir el
          cumplimiento de acuerdos o contratos suscritos con Progreso; tales
          como nombre, domicilio, teléfono, correo electrónico, fecha y lugar de
          nacimiento, datos migratorios, Rol Único Tributario, estado civil,
          datos académicos, datos de identificación y contacto, datos
          biométricos y de geolocalización, datos patrimoniales, datos deuda
          vigente, motivo del crédito, tipo de negocio, claves de acceso que
          permitan acceder a fuentes de ingresos, egresos, declaraciones de pago
          de impuestos u otra información relevante para evaluaciones
          comerciales en el Servicio de Impuestos Internos (“SII”), Tesorería
          General de la República u otros organismos de similar naturaleza,
          verificación de datos a través de redes sociales, información sobre
          navegación en el sitio web y aplicaciones móviles de Progreso, por
          ejemplo, el tipo de dispositivo con el que se conecta, sistema
          operativo y navegador web, el número identificador de dispositivo de
          red (dirección MAC) dirección IP, entre otros.
        </TextoAviso>
        <TextoAviso>
          Algunos de los productos o servicios que ofrece Progreso implican el
          tratamiento de datos de terceros, tales como la empresa a la cual el
          Usuario representa y sus representantes legales o apoderados,
          incluyendo nombre, domicilio, teléfono, correo electrónico, Rol Único
          Tributario, información relativa a créditos, datos patrimoniales,
          datos de deuda vigente, motivo del crédito, tipo de negocio, datos de
          identificación y contacto, verificación de datos a través de fuentes
          de acceso público , claves de acceso que permitan acceder a fuentes de
          ingresos, egresos, declaraciones de pago de impuestos u otra
          información relevante para evaluaciones comerciales en el Servicio de
          Impuestos Internos (“SII”), Tesorería General de la República u otros
          organismos de similar naturaleza; los cuales, han sido previamente
          facilitados por parte del Usuario, se entenderán como Datos Personales
          a efectos de lo dispuesto en la presente Política de Privacidad. Al
          proporcionar Datos Personales de terceros, el Usuario declara contar
          con la autorización necesaria para ello, habiéndole informado de las
          finalidades y de la forma en que dichos Datos Personales serán
          tratados.
        </TextoAviso>
        <TextoAviso>
          Algunos de los productos o servicios que ofrece Progreso, implican el
          tratamiento de datos de terceros, tales como la empresa a la cual el
          Usuario representa y sus representantes legales o apoderados,
          incluyendo nombre, domicilio, teléfono, correo electrónico, Rol Único
          Tributario, información relativa a créditos, datos patrimoniales,
          datos de deuda vigente, motivo del crédito, tipo de negocio, datos de
          identificación y contacto, verificación de datos a través de fuentes
          de acceso público , claves de acceso que permitan acceder a fuentes de
          ingresos, egresos, declaraciones de pago de impuestos u otra
          información relevante para evaluaciones comerciales en el Servicio de
          Impuestos Internos (“SII”), Tesorería General de la República u otros
          organismos de similar naturaleza; los cuales, han sido previamente
          facilitados por parte del Usuario, se entenderán como Datos Personales
          a efectos de lo dispuesto en la presente Política de Privacidad. Al
          proporcionar Datos Personales de terceros, el Usuario declara contar
          con la autorización necesaria para ello, habiéndole informado de las
          finalidades y de la forma en que dichos Datos Personales serán
          tratados.
        </TextoAviso>
        <TextoAviso>
          Adicionalmente, el Usuario, actuando por sí y/o por las personas que
          representa, otorga por este acto un mandato especial revocable en
          cualquier tiempo, para que Progreso o los Proveedores, según dicho
          término se define más adelante, y según fuere únicamente necesario a
          los fines que regula esta Política de Privacidad, acceda en su
          representación a las fuentes o bancos de Datos Personales en que éstos
          se contengan, incluyendo tanto organismos o entidades públicos y
          privados y especialmente pero no limitado ante el SII y la Tesorería
          General de la República, a efectos de revisar, corroborar, copiar o
          extraer Datos Personales. Bajo circunstancia alguna Progreso o los
          Proveedores podrán, en el uso del presente mandato, realizar
          operaciones, transacciones, declaraciones, rectificaciones ni
          actividad alguna distinta de aquellas señaladas precedentemente.
          Progreso se obliga a rendir cuenta de este mandato en cualquier
          momento que el Usuario lo solicite.
        </TextoAviso>
        <TextoAviso>
          El Usuario es el responsable de mantener actualizados todos los Datos
          Personales que entregue a Progreso, para la debida prestación de los
          servicios que este ofrece. En consecuencia, el Usuario garantiza y
          responde de la veracidad, exactitud, vigencia y autenticidad de los
          Datos Personales facilitados, y se compromete a mantenerlos
          debidamente actualizados, comunicando a Progreso cualquier cambio al
          respecto. Progreso no recaba datos personales sensibles, que se
          refieren a las características físicas o morales de las personas o a
          hechos o circunstancias de su vida privada o intimidad, tales como el
          origen racial, las ideologías y opiniones políticas, las creencias o
          convicciones religiosas, los estados de salud físicos o psíquicos, la
          vida sexual u otros que pudiere establecer la Ley
        </TextoAviso>

        <CabeceraSeccion>II. USO DE DATOS</CabeceraSeccion>
        <TextoAviso>
          Los Datos Personales recabados son utilizados para brindar los
          servicios que Progreso ofrece, incluyéndose especialmente, pero no
          limitado, a:
        </TextoAviso>
        <OrderedList spacing={3}>
          <ListItem>
            A través de Progreso, así como la administración, operación y
            seguimiento a los servicios y productos contratados, y para requerir
            el cumplimiento de acuerdos o contratos suscritos por el Usuario con
            Progreso; gestionar y ejecutar los contratos que el Usuario celebre
            con o
          </ListItem>
          <ListItem>
            Responder a las consultas, reclamos, solicitudes del Usuario, u
            otras acciones que requieran ser realizadas derivadas de la
            solicitud y/o contratación de los servicios que Progreso ofrece;
          </ListItem>
          <ListItem>
            Verificar, confirmar y validar la identidad del Usuario y de la
            persona jurídica a la que representa, así como la veracidad de la
            información que proporciona, referencias, obligados solidarios,
            avales, según resulte aplicable de acuerdo al servicio contratado
            con Progreso; para lo cual Progreso podrá realizar los análisis,
            reportes, video-llamadas y/o fotografías, realizar entrevistas
            presenciales o por medios remotos, medios electrónicos o cualquier
            otra tecnología;
          </ListItem>
          <ListItem>
            Verificar e investigar la capacidad financiera y crediticia ante
            sociedades de información financiera y crediticia que estime
            conveniente, Servicio de Impuestos Internos, Tesorería General de la
            República u otras entidades de similar naturaleza, realizar el
            análisis de la información proporcionada por el Usuario, utilizar
            modelos predictivos de comportamiento y score de riesgos, a fin de
            determinar conforme a las disposiciones legales vigentes el nivel de
            riesgo, viabilidad de pago, perfil transaccional, y cualquier otra
            evaluación que sea requerida por la normativa para el otorgamiento
            de servicios financieros;
          </ListItem>
          <ListItem>
            Contactar al Usuario a través de nuestros canales de comunicación
            tanto físicos como remotos, o enviar comunicaciones a los datos de
            contacto que haya informado a Progreso, con el objeto de hacer
            llegar información sobre los servicios, sobre actualizaciones de los
            mismos o relacionada con las finalidades descritas en esta Política
            de Privacidad
          </ListItem>
          <ListItem>
            Realizar acciones de marketing, de carácter general o dirigidas
            personalmente al Usuario, y, así, mejorar los servicios que Progreso
            ofrece y la experiencia del Usuario como cliente; pudiendo analizar
            y elaborar estudios estadísticos sobre los intereses y hábitos de
            compra e inversión de los usuarios, necesidades de capital de
            trabajo y, en términos generales, sobre materias relevantes para la
            preparación de estudios de mercado o campañas de marketing propias o
            de terceros; y enviar ofertas, promociones, boletines y anuncios
            publicitarios de productos y servicios que puedan ser de interés del
            Usuario;
          </ListItem>
          <ListItem>
            Desarrollar inteligencia comercial, elaborar un perfil de usuario,
            individual o agregado, aplicando o no modelos predictivos,
            seguimiento de calidad de las plataformas que Progreso pone a
            disposición de sus Usuarios, realizar encuestas de satisfacción e
            investigaciones de mercado
          </ListItem>
          <ListItem>
            Completar automáticamente los documentos necesarios para realizar
            transacciones en el sitio web de Progreso (
            <TextoAviso
              as={Link}
              to={'www.progreso.cl'}
              target='_blank'
              color={'bGreen.700'}
            >
              www.progreso.cl
            </TextoAviso>
            ), sus aplicaciones informáticas / web, u otras plataformas que este
            habilite para prestar los servicios contratados;
          </ListItem>
          <ListItem>
            Realizar campañas de actualización de Datos Personales, y acciones
            de cobranza;
          </ListItem>
          <ListItem>
            Ejecutar protocolos de seguridad, y para prevenir y detectar usos
            engañosos, fraudulentos o criminales de nuestros sistemas e
            instalaciones, lo cual es necesario para proteger los intereses
            legítimos de Progreso y de sus clientes.
          </ListItem>
        </OrderedList>
        <CabeceraSeccion>
          III. TRANSFERENCIA DE DATOS PERSONALES
        </CabeceraSeccion>
        <TextoAviso>
          Progreso podrá contratar a terceros proveedores de servicios tales
          como marketing; evaluación crediticia y comercial; investigaciones de
          fraude y recolección de pagos; recolección, procesamiento y
          disposición de información, entre otros (en adelante, los
          “Proveedores”), quienes desarrollarán tales tareas como encargados de
          Progreso, siguiendo sus instrucciones y de conformidad a un contrato
          vigente de prestación de servicios que este celebre con ellos.
        </TextoAviso>
        <TextoAviso>
          Al aceptar la presente Política de Privacidad, el Usuario acepta y
          autoriza a Progreso para que pueda compartir con los Proveedores los
          Datos Personales del Usuario y de las empresas a las que este
          represente, quienes podrán tratar tales datos para dar cumplimiento al
          encargo específico encomendado por Progreso; sometiéndose al efecto, a
          los términos de esta Política de Privacidad y a la Ley 19.628 sobre
          Protección de la Vida Privada, adoptando medidas de seguridad y
          confidencialidad adecuadas para el tratamiento de los Datos Personales
          que el Usuario provea.
        </TextoAviso>
        <TextoAviso>
          Adicionalmente, el Usuario acepta y autoriza a Progreso para que
          comparta sus Datos Personales con terceros, incluidos entidades
          financieras, para la cesión o descuento de cartera de crédito, endoso
          o cualquier otra forma de negociación de la cartera crediticia; con
          sociedades controladoras de Progreso, subsidiarias o afiliadas bajo el
          control común, su sociedad matriz o a cualquier sociedad de su grupo
          corporativo que opere bajo los mismos procesos y políticas internas
          que Progreso; con otras empresas en caso de que Progreso sea
          adquirido, fusionado o cualquier otra operación similar por esa
          compañía; y con socios comerciales con quienes Progreso haya celebrado
          contratos para la comercialización de productos y/o servicios en
          beneficio de los clientes.
        </TextoAviso>
        <TextoAviso>
          Lo anterior se entiende sin perjuicio de aquellos casos en que, por
          requerimiento de la autoridad competente, Progreso deba hacer entrega
          de tales datos de conformidad a la normativa aplicable; o de los casos
          de tratamiento de Datos Personales que de conformidad a la Ley 19.628
          sobre Protección de la Vida Privada, no requieran de autorización
          especial.
        </TextoAviso>
        <TextoAviso>
          Progreso será Responsable del tratamiento de los Datos Personales que
          realicen los Proveedores u otros terceros, sin perjuicio de la
          responsabilidad que a cada uno de ellos corresponda por incumplimiento
          de sus obligaciones, de conformidad a la Ley 19.628 sobre Protección
          de la Vida Privada.
        </TextoAviso>
        <CabeceraSeccion>
          IV. USO DE COOKIES Y TECNOLOGÍAS SIMILARES
        </CabeceraSeccion>
        <TextoAviso>
          Progreso podrá utilizar cookies y tecnologías similares para
          personalizar y mejorar la experiencia del Usuario. Las cookies son
          archivos pequeños de texto que se almacenan en el computador o
          dispositivo móvil a través de los que el Usuario accede al sitio web o
          aplicación de Progreso, de manera que pueden ser reconocidos cada vez
          que el Usuario vuelva a visitar estos sitios o aplicaciones móviles,
          otorgando información sobre preferencias y pautas de navegación.
        </TextoAviso>
        <TextoAviso>
          El Usuario puede elegir deshabilitar en cualquier momento algunas o
          todas las cookies que Progreso pueda utilizar, para lo cual deberá
          consultar las instrucciones de su navegador. Sin embargo, esto podría
          restringir el uso del sitio web y aplicaciones móviles de Progreso, y
          limitar la experiencia del Usuario en los mismos ya que ciertas
          funcionalidades de estos sitios podrían no funcionar con cookies
          desactivadas.
        </TextoAviso>
        <TextoAviso>
          Los medios electrónicos utilizados por Progreso pueden incluir enlaces
          a sitios web de terceros ajenos a ella, respecto de los cuales esta
          última no asume ninguna titularidad, obligación o responsabilidad
          alguna.
        </TextoAviso>
        <CabeceraSeccion>V. DERECHOS DEL USUARIO</CabeceraSeccion>
        <TextoAviso>
          El Usuario tiene derecho a acceder a sus Datos Personales, información
          sobre su procedencia y destinatario, el propósito del almacenamiento y
          la individualización de las personas u organismos a los cuales sus
          datos son transmitidos regularmente; y en caso de que los Datos
          Personales recolectados sean erróneos, inexactos, equívocos o
          incompletos, y así se acredite, tendrá derecho a que se modifiquen.
        </TextoAviso>
        <TextoAviso>
          Adicionalmente, el Usuario tiene derecho a revocar en cualquier
          momento, aunque sin efecto retroactivo, la autorización que entrega a
          Progreso para el tratamiento de sus Datos Personales en conformidad a
          esta Política de Privacidad, en cuyo caso es posible que el Usuario no
          pueda acceder a alguno o todos los servicios que ofrece Progreso. Del
          mismo modo, el Usuario siempre podrá solicitar la suspensión de
          comunicaciones promocionales o publicitarias.
        </TextoAviso>
        <TextoAviso>
          Para ejercer sus derechos de acceso, rectificación, supresión o
          cancelación, bloqueo, portabilidad y oposición, y todos los demás
          derechos que le confiera la Ley N° 19.628 sobre Protección de la Vida
          Privada, así como para solicitar la suspensión de comunicaciones
          promocionales o publicitarias; el Usuario deberá enviar un correo
          electrónico a privacidad@progreso.cl con indicación de su nombre,
          datos de contacto, e indicación del derecho o derechos que se desea
          ejercer. Progreso podrá solicitar información adicional a objeto de
          acreditar su identidad o en su caso, la representación legal que
          inviste. Progreso sólo podrá negar el ejercicio de derechos antes
          señalados en los supuestos que la Ley 19.628 sobre Protección de la
          Vida Privada lo permita.
        </TextoAviso>
        <CabeceraSeccion>VI. RESPONSABILIDAD DEL USUARIO</CabeceraSeccion>
        <TextoAviso>
          Progreso mantiene salvaguardias físicas, electrónicas y de
          procedimiento con el objeto de salvaguardar los Datos Personales del
          Usuario, y evitar el acceso no autorizado o ilegal, o la pérdida
          accidental, destrucción u ocurrencia de daños; y si bien no es posible
          garantizar lo anterior, los sistemas con los que cuenta Progreso han
          probado ser efectivos en el manejo de información reservada,
          impidiendo hackeos u otras amenazas externas. Sin perjuicio de lo
          antes señalado, se recomienda al Usuario no enviar datos desde sitios
          o equipos públicos o no seguros.
        </TextoAviso>
        <TextoAviso>
          Es exclusiva responsabilidad del Usuario la protección contra el
          acceso no autorizado a sus contraseñas, computadores y dispositivos
          móviles.
        </TextoAviso>
        <TextoAviso>
          Toda operación que se realice utilizando los datos de acceso y claves
          del Usuario en cualquiera de los canales de Progreso, será considerada
          realizada por el Usuario, salvo que previamente nos haya comunicado
          que su identificación, firma electrónica, cuenta de Usuario,
          contraseña, dispositivo móvil o cualquier otra medida de autenticación
          que se implemente para el uso de los servicios que Progreso ofrece,
          han sido extraviados o podrían estar siendo utilizados por un tercero
          no autorizado, en cuyo caso, activaremos los [protocolos de seguridad
          correspondientes.
        </TextoAviso>
        <CabeceraSeccion>
          VII. PLAZO DE ALMACENAMIENTO DE DATOS PERSONALES
        </CabeceraSeccion>
        <TextoAviso>
          Progreso mantendrá los Datos Personales que los Usuarios le
          proporcionen mientras sean necesarios para la finalidad para las
          cuales se recolectaron, salvo aquellos que por disposiciones legales o
          regulatorias deban ser mantenidos por períodos de tiempo que van más
          allá de este término, en cuyo caso se mantendrán por el periodo que
          indique esa normativa.
        </TextoAviso>
        <CabeceraSeccion>
          VIII. VIGENCIA DE LA POLÍTICA DE PRIVACIDAD
        </CabeceraSeccion>
        <TextoAviso>
          La presente Política de Privacidad tiene duración indefinida. Sin
          embargo, Progreso podrá hacer modificaciones, cambios y/o
          actualizaciones a esta Política de Privacidad que sean necesarias para
          atender disposiciones legales aplicables o por otras causas, lo cual
          será informado al Usuario mediante publicación en las Plataformas
          Progreso, [o incluso a la dirección de correo electrónico informada
          por el Usuario cuando el cambio en cuestión sea significativo].
        </TextoAviso>
        <TextoAviso>
          Es responsabilidad del Usuario la lectura y acatamiento de la Política
          de Privacidad, así como de sus actualizaciones, una vez que estas sean
          informadas de conformidad a lo antes expuesto.
        </TextoAviso>
        <CabeceraSeccion>
          IX. ACEPTACIÓN DE LA POLÍTICA DE PRIVACIDAD
        </CabeceraSeccion>
        <TextoAviso>
          En este acto, el Usuario acepta y reconoce haber revisado
          detenidamente la Política de Privacidad de Progreso y declara que al
          presionar el botón de [“Aceptar”] siguiente, acepta de manera
          voluntaria, expresa, inequívoca e irrevocablemente las estipulaciones
          de la misma.
        </TextoAviso>
        <TextoAviso>
          En razón de lo anterior, el Usuario al presionar el botón de “Aceptar”
          también autoriza expresamente a Progreso a tratar los Datos Personales
          que proporcione, por cualquiera de sus canales de comunicación o
          venta, tanto presenciales como remotos. Asimismo, y siempre que no
          existan restricciones legales para ello, el Usuario autoriza a
          Progreso a compartir sus Datos Personales, de conformidad a lo
          indicado en la Sección III anterior.
        </TextoAviso>
      </ContenidoAviso>
    </ContenedorAviso>
  );
};

export default Politicas;
